<div *ngIf="active" class="field-validation-error caption">
  <ng-content></ng-content>
</div>
